import { atom } from "recoil";
import { getProfilePhotoFromStorage } from "../utils/photoStorage";

export const photoFetchStatusState = atom<'idle' | 'success' | 'failed'>({
    key: "photoFetchStatusState",
    default: "idle",
});

export const fotoProfileUrlState = atom<string | null>({
    key: "fotoProfileUrlState",
    default: getProfilePhotoFromStorage(),
});